(() => {
  if (typeof window.Lenis !== 'function' || window.Shopify?.designMode) return;
  const motion = matchMedia('(prefers-reduced-motion: no-preference)');
  let instance = null;
  let observer = null;
  const syncLock = () => {
    if (!instance) return;
    const locked = getComputedStyle(document.body).overflowY === 'hidden' ||
      document.documentElement.style.overflow === 'hidden';
    if (locked) instance.stop();
    else instance.start();
  };
  const destroy = () => {
    observer?.disconnect();
    observer = null;
    if (window.lenis === instance) delete window.lenis;
    instance?.destroy();
    instance = null;
  };
  const configure = () => {
    if (!motion.matches) { destroy(); return; }
    if (instance) { syncLock(); return; }
    instance = new window.Lenis({
      autoRaf: true,
      lerp: 0.18,
      wheelMultiplier: 1,
      smoothWheel: true,
      syncTouch: false,
      anchors: { offset: -100 },
      respectReducedMotion: true,
      stopInertiaOnNavigate: true,
      prevent: node => node.matches('.drawer, .menu-drawer, .modal, dialog, textarea, select, [contenteditable="true"]'),
    });
    window.lenis = instance;
    observer = new MutationObserver(syncLock);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    syncLock();
  };
  motion.addEventListener('change', configure);
  window.addEventListener('resize', syncLock, { passive: true });
  window.addEventListener('pagehide', destroy);
  window.addEventListener('pageshow', configure);
  configure();
})();
